import { IApplicationState } from '../../types/redux';
import { getNewBuildings } from '../newBuildings';

export function getNewbuildingsCounts(state: IApplicationState) {
  const newbuildingsState = getNewBuildings(state);

  return newbuildingsState.tabs;
}
